export default __webpack_public_path__ + "static/marco-tanzola-d76b5ffb8f5daafa09a0fcc15a661e24.jpg";